import { useLayoutEffect, useState } from "react";

export function useAnchorWidth<T extends HTMLElement>() {
  const [anchorEl, setAnchorEl] = useState<T | null>(null);
  const [anchorWidth, setAnchorWidth] = useState<number>(0);

  useLayoutEffect(() => {
    if (!anchorEl) {
      return;
    }

    const updateWidth = () => {
      setAnchorWidth(anchorEl.getBoundingClientRect().width);
    };

    updateWidth();

    const resizeObserver = new ResizeObserver(() => {
      updateWidth();
    });

    resizeObserver.observe(anchorEl);

    return () => {
      resizeObserver.disconnect();
    };
  }, [anchorEl]);

  const updateAnchor = (el: T | null) => {
    setAnchorEl(el);
    if (el) {
      setAnchorWidth(el.getBoundingClientRect().width);
    }
  };

  return { anchorEl, anchorWidth, updateAnchor };
}
